module.exports = __webpack_public_path__ + "img/CCAF.1fa6ea35.png";